<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    title="产品详情"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    width="70%"
    top="5%"
    class="ds-detail"
    append-to-body
    :close-on-click-modal="false"
  >
    <div class="border-style">点位信息</div>

    <el-form :model="stationItem" label-width="150px">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="点位名称">
            <el-input
              v-model.trim="stationItem.Name"
              placeholder="请输入点位名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12"
          ><el-form-item label="标签" prop="Tags">
            <el-select
              v-model="stationItem.Tags"
              :multiple-limit="6"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="请选择或创建标签"
              style="width: 100%"
            >
              <el-option
                v-for="(tag, index) in tagList"
                :key="index"
                :label="tag"
                :value="tag"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="stationItem.IsEdited === true">
        <span style="font-size: small; color: red; padding-left: 150px"
          ><i class="el-icon-info" style="color: #f56c6c"></i
          >说明：已人工修改，如要恢复成自动更新下位信息，点击“恢复自动更新”按钮</span
        >
      </div>
      <el-form-item label="MN">
        <el-input
          v-model.trim="stationItem.MN"
          placeholder="请输入MN"
        ></el-input>
      </el-form-item>
      <el-form-item label="说明">
        <el-input
          v-model.trim="stationItem.Content"
          :autosize="{ minRows: 1 }"
          type="textarea"
          placeholder="请输入说明"
        ></el-input>
      </el-form-item>

      <div
        style="
          margin-top: -10px;
          word-wrap: break-word;
          word-break: break-all;
          padding-left: 150px;
        "
      >
        <span style="font-size: small">
          <i class="el-icon-info" style="color: #e6a23c"></i>下位获取点位名称：
          <span
            style="color: red"
            v-if="stationItem.LastName !== stationItem.Name"
          >
            {{ stationItem.LastName }}
          </span>
          <span v-else> {{ stationItem.LastName }} </span>
        </span>
        <span style="font-size: small; padding-left: 150px"
          >MN:
          <span style="color: red" v-if="stationItem.LastMN !== stationItem.MN">
            {{ stationItem.LastMN }}
          </span>
          <span v-else> {{ stationItem.LastMN }} </span>
        </span>
      </div>

      <div style="text-align: right; padding-bottom: 40px; padding-top: 5px">
        <div style="float: left; text-align: left; width: 60%">
          <el-button
            type="primary"
            @click="onUseDciInfo"
            size="mini"
            v-permission="'dci_station_restoreupdate-PUT'"
          >
            <i class="el-icon-document-copy"></i> 使用下位点位名称MN
          </el-button>
          <el-button
            type="primary"
            @click="onResumeUpdate"
            size="mini"
            v-permission="'dci_station_restoreupdate-PUT'"
          >
            <i class="el-icon-refresh"></i> 恢复自动更新
          </el-button>
        </div>
        <div style="float: right; text-align: right; width: 40%">
          <el-button
            type="primary"
            @click="onSaveStation"
            :disabled="editting"
            size="mini"
            v-permission="'dci_station-PUT'"
          >
            <i class="fas fa-save"></i> 保 存
          </el-button>
        </div>
      </div>
    </el-form>

    <div class="border-style">产品信息</div>
    <el-form :model="item" label-width="150px">
      <table
        border="1"
        bordercolor="#dedede"
        style="
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
          margin-bottom: 15px;
        "
      >
        <tr height="40">
          <th width="15%">产品型号名称</th>
          <td width="35%">
            <div v-if="item.DciProductModel">
              {{ item.DciProductModel.Name }}
            </div>
          </td>
          <th width="15%">产品型号</th>
          <td width="35%">
            <div v-if="item.DciProductModel">
              {{ item.DciProductModel.Number }}
            </div>
          </td>
        </tr>
        <tr height="40">
          <th>产品SN</th>
          <td>{{ item.SNRemark }}</td>
          <th>文件系统版本</th>
          <td>
            <div v-if="item.DciPvProductVersion">
              {{ item.DciPvProductVersion.PvName }}
            </div>
          </td>
        </tr>
        <tr height="40">
          <th>质保开始日期</th>
          <td v-if="item.QualityStartAt">
            {{ $sys.dateFormat(item.QualityStartAt, "Y-m-d") }}
          </td>
          <td v-else></td>
          <th>质保结束日期</th>
          <td v-if="item.QualityEndAt">
            {{ $sys.dateFormat(item.QualityEndAt, "Y-m-d") }}
          </td>
          <td v-else></td>
        </tr>
        <tr height="40">
          <th>客户</th>
          <td>{{ item.ClientName }}</td>
          <th>出库日期</th>
          <td v-if="item.StockoutAt">
            {{ $sys.dateFormat(item.StockoutAt, "Y-m-d") }}
          </td>
          <td v-else></td>
        </tr>
        <tr height="40">
          <th>出库单号</th>
          <td>{{ item.CheckoutNo }}</td>
          <th>出库经办人</th>
          <td>{{ item.Operator }}</td>
        </tr>
        <tr height="40">
          <th>合同编号</th>
          <!-- <td>{{ item.ContractNo }}</td> -->
          <td>
            <el-tag
              v-for="contractNo in item.ContractNos"
              :key="contractNo"
              style="margin-right: 5px; color: #00b3ca"
              >{{ contractNo }}</el-tag
            >
          </td>
          <th>领用人</th>
          <td>{{ item.Recipient }}</td>
        </tr>
        <tr height="40">
          <th>状态</th>
          <td>{{ item.StatusName }}</td>
          <th>出库备注</th>
          <td>{{ item.StockoutReason }}</td>
        </tr>
      </table>
      <div
        style="text-align: left; font-size: smaller"
        v-if="
          item.DciProductExtendWarranties &&
          item.DciProductExtendWarranties.length > 0 &&
          item.DciProductExtendWarranties[
            item.DciProductExtendWarranties.length - 1
          ].DownloadUrls &&
          item.DciProductExtendWarranties[
            item.DciProductExtendWarranties.length - 1
          ].DownloadUrls.length > 0
        "
      >
        <span
          style="padding-left: 10px"
          v-for="attachment in item.DciProductExtendWarranties[
            item.DciProductExtendWarranties.length - 1
          ].DownloadUrls"
          :key="attachment.Url"
        >
          <a
            target="_blank"
            :href="attachment.Url"
            :download="attachment.Name"
            style="color: #409eff"
            >{{ attachment.Name }}</a
          >
        </span>
      </div>
      <div style="text-align: right; padding-bottom: 10px">
        <el-button
          type="primary"
          size="mini"
          @click="onUpdateStatusClick"
          v-permission="'dci_station_product-POST'"
        >
          <i class="far fa-save"></i> 更改状态
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="onUpdateQCDateClick"
          v-permission="'dci_station_product_extendedwarranty-POST'"
        >
          <i class="far fa-save"></i> 更新质保期
        </el-button>
      </div>
    </el-form>

    <div class="border-style">运维信息</div>
    <el-form :model="contractItem" label-width="150px">
      <table
        border="1"
        bordercolor="#dedede"
        style="
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
          margin-bottom: 15px;
        "
      >
        <tr height="40">
          <th width="15%">运维合同编号</th>
          <td width="35%" v-if="contractItem">
            {{ contractItem.sn }}
          </td>
          <td v-else></td>
          <th width="15%">合同客户企业</th>
          <td width="35%" v-if="contractItem && contractItem.Partner">
            {{ contractItem.Partner.name }}
          </td>
          <td v-else></td>
        </tr>
        <tr height="40">
          <th>运维开始日期</th>
          <td v-if="contractItem && contractItem.begin_at">
            {{ $sys.dateFormat(contractItem.begin_at, "Y-m-d") }}
          </td>
          <td v-else></td>
          <th>运维结束日期</th>
          <td v-if="contractItem && contractItem.end_at">
            {{ $sys.dateFormat(contractItem.end_at, "Y-m-d") }}
          </td>
          <td v-else></td>
        </tr>
        <tr height="40">
          <th>负责小组</th>
          <td v-if="contractItem">
            {{ contractItem.team_name }}
          </td>
          <td v-else></td>
          <th>负责人</th>
          <td v-if="contractItem">
            {{ contractItem.staff_name }}
          </td>
          <td v-else></td>
        </tr>
      </table>
    </el-form>

    <div class="border-style">配件列表</div>
    <el-table :data="accList">
      <el-table-column type="index" width="40"></el-table-column>
      <el-table-column
        prop="DciAccessoryModel.NameNumber"
        label="配件型号名称"
      />
      <el-table-column prop="SN" label="配件SN" width="250">
        <template slot-scope="{ row }">
          <el-tag>
            {{ row.SN }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="出库日期" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.StockoutAt">
            {{ $sys.dateFormat(scope.row.StockoutAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="质保开始日期" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.QualityStartAt">
            {{ $sys.dateFormat(scope.row.QualityStartAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="质保结束日期" width="110">
        <template slot-scope="scope">
          <div v-if="scope.row.QualityEndAt">
            {{ $sys.dateFormat(scope.row.QualityEndAt, "Y-m-d") }}
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="更新状态"
      :visible.sync="statusVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="statusVisible = false"
      width="30%"
    >
      <el-form
        ref="statusItemForm"
        label-width="120px"
        :model="statusItem"
        :rules="statusRules"
      >
        <el-form-item label="状态" prop="Status">
          <!-- <el-select
            v-model="statusItem.Status"
            placeholder="请选择状态"
            style="width: 100%"
          >
            <el-option
              v-for="status in statusList"
              :key="status.Key"
              :label="status.Value"
              :value="status.Key"
            ></el-option>
          </el-select> -->
          <el-select
            v-model="statusItem.Status"
            placeholder="请选择状态"
            style="width: 100%"
          >
            <el-option label="已出库" :value="2"></el-option>
            <el-option label="已激活" :value="4"></el-option>
            <el-option label="维修中" :value="7"></el-option>
            <el-option label="已停用" :value="8"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作日期" prop="DatedAt">
          <el-date-picker
            v-model="statusItem.DatedAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="Reason">
          <el-input
            v-model.trim="statusItem.Reason"
            :autosize="{ minRows: 3 }"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="statusVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          @click="onUpdateStatus"
          :disabled="statusSubmitting"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="更新质保期"
      :visible.sync="qualityVisible"
      append-to-body
      :close-on-click-modal="false"
      @close="qualityVisible = false"
      width="30%"
    >
      <el-form
        ref="qualityItemForm"
        label-width="120px"
        :model="qualityItem"
        :rules="qualityRules"
      >
        <el-form-item label="质保开始日期" prop="QualityStartAt">
          <el-date-picker
            v-model="qualityItem.QualityStartAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="质保结束日期" prop="QualityEndAt">
          <el-date-picker
            v-model="qualityItem.QualityEndAt"
            style="width: 100%"
            type="date"
            placeholder="请选择日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="合同编号" prop="ContractNumber">
          <el-input
            v-model.trim="qualityItem.ContractNumber"
            placeholder="请输入合同编号"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input
            v-model.trim="qualityItem.Remark"
            :autosize="{ minRows: 2 }"
            type="textarea"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
        <el-form-item label="文件上传" prop="file">
          <el-upload
            ref="upload"
            action=""
            :http-request="httpRequest"
            :headers="uploadHeader"
            :on-remove="handleRemove"
            :on-error="handleError"
          >
            <el-button size="mini" type="primary">选择文件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="qualityVisible = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          type="primary"
          @click="onUpdateQCDate"
          :disabled="qualitySubmitting"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import axi from "axios";
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    return {
      ID: "",
      proItem: _.clone(this.value),
      item: {}, //产品信息
      stationItem: {}, //站点信息
      accList: [], //配件列表
      tagList: [], //标签
      statusList: [], //状态
      editting: false,
      isEdited: false, //当天页面有没有修改过信息

      statusVisible: false,
      statusSubmitting: false,
      statusItem: {
        DatedAt: new Date(),
        Status: -1,
        Reason: "",
      },
      statusName: "",
      statusRules: {
        Status: [{ required: true, message: "状态不能为空", trigger: "blur" }],
        DatedAt: [
          { required: true, message: "操作日期不能为空", trigger: "blur" },
        ],
        Reason: [{ required: true, message: "备注不能为空", trigger: "blur" }],
      },

      qualityVisible: false,
      qualitySubmitting: false,
      qualityItem: {
        DciProductID: "",
        QualityStartAt: new Date(),
        QualityEndAt: new Date(new Date().getTime() + 3600 * 1000 * 24 * 365),
        ContractNumber: "",
        CreatedUserID: "",
        Attachments: [],
        Remark: "",
      },
      qualityRules: {
        QualityStartAt: [
          { required: true, message: "质保开始日期不能为空", trigger: "blur" },
        ],
        QualityEndAt: [
          { required: true, message: "质保结束日期不能为空", trigger: "blur" },
        ],
        ContractNumber: [
          { required: true, message: "合同编号不能为空", trigger: "blur" },
        ],
      },
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      uploadUrl: "dci/product/extendedwarranty/attachment",
      fileList: [],
      removeList: [],

      //运维合同信息
      contractItem: {
        id: "",
        sn: "", //合同编号
        begin_at: "",
        end_at: "",
        team_name: "", //负责小组
        staff_name: "", //负责人
        partner_id: "",
        Partner: {
          id: "",
          name: "", //合同客户企业
        },
      },
    };
  },
  methods: {
    onOpen() {
      this.proItem = _.cloneDeep(this.value);
      this.ID = this.proItem.ID;
      this.initData();
      this.getTagList();
      this.getStatusList();
    },
    initData() {
      this.item = {};
      this.stationItem = {};
      this.accList = [];
      this.contractItem = {};

      this.$axios
        .get(`dci/product/${this.ID}`)
        .then((response) => {
          this.item = response.data;
          this.stationItem = this.item.DciStation;
          this.accList = this.item.DciAccessories;

          if (this.stationItem && this.stationItem.MN != "") {
            this.$axios
              .get("dci/station/getContractInfo", {
                params: { mn: this.stationItem.MN },
              })
              .then((response) => {
                this.contractItem = response.data;
              })
              .catch(({ response }) => {
                // this.$sys.alarmResponse(response);
              });
          }
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getTagList() {
      this.$axios
        .get("dci/station/tag")
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getStatusList() {
      this.$axios
        .get("dci/product/stock-status-list")
        .then((response) => {
          this.statusList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 使用下位点位名称MN
    onUseDciInfo() {
      this.stationItem.Name = this.stationItem.LastName;
      this.stationItem.MN = this.stationItem.LastMN;
      this.onSaveStation();
    },

    // 恢复自动更新
    onResumeUpdate() {
      this.$axios
        .request({
          url: `dci/station/restoreupdate/${this.stationItem.ID}`,
          method: "put",
        })
        .then((response) => {
          this.isEdited = true;
          this.stationItem = response.data;
          this.$message.success("操作成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    //保存点位信息
    onSaveStation() {
      this.editting = true;
      this.$emit("input", this.stationItem);
      const itemData = { ...this.stationItem };
      // 保存的操作
      this.$axios
        .request({
          url: `dci/station/${this.stationItem.ID}`,
          method: "put",
          data: itemData,
        })
        .then((response) => {
          this.isEdited = true;
          this.stationItem = response.data;
          this.$message.success("保存成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.editting = false;
        });
    },

    //点击更新状态按钮
    onUpdateStatusClick() {
      this.statusVisible = true;
      this.statusItem.Status = this.item.Status;
      this.statusItem.DatedAt = new Date();
      this.statusItem.Reason = "";
    },
    //更新状态
    onUpdateStatus() {
      this.$refs.statusItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.statusSubmitting = true;
        this.$axios
          .request({
            url: "dci/product/status-edit",
            method: "post",
            data: {
              ID: this.item.ID,
              Status: this.statusItem.Status,
              DatedAt: this.statusItem.DatedAt,
              Reason: this.statusItem.Reason,
            },
          })
          .then(() => {
            this.statusSubmitting = false;
            this.statusVisible = false;
            this.item.Status = this.statusItem.Status;
            const statusItem = this.statusList.find(
              (s) => s.Key === this.statusItem.Status
            );
            this.item.StatusName = statusItem.Value;

            this.isEdited = true;
            this.$message.success("更新成功");
          })
          .catch(({ response }) => {
            this.statusSubmitting = false;
            this.$sys.alarmResponse(response);
          });
      });
    },

    //点击更新质保期按钮
    onUpdateQCDateClick() {
      this.qualityVisible = true;

      this.qualityItem.DciProductID = this.item.ID;
      this.qualityItem.QualityStartAt = this.item.QualityStartAt;
      this.qualityItem.QualityEndAt = this.item.QualityEndAt;
      this.qualityItem.ContractNumber = "";
      this.qualityItem.CreatedUserID = this.$store.state.Auth.user.ID;
      this.qualityItem.Attachments = [];
      this.qualityItem.Remark = "";

      if (this.fileList.length > 0) {
        this.$refs.upload.clearFiles();
      }
      this.fileList = [];
      this.removeList = [];
    },

    //更新质保期
    onUpdateQCDate() {
      this.$refs.qualityItemForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.qualitySubmitting = true;

        //排除删除的附件
        if (this.removeList.length !== 0) {
          let urls = [];
          this.removeList.forEach((rid) => {
            this.fileList.forEach((file) => {
              if (rid === file.uid) {
                urls.push(file.url);
              }
            });
          });

          urls.forEach((url) => {
            this.qualityItem.Attachments.splice(
              this.qualityItem.Attachments.findIndex(
                (item) => item.Url === url
              ),
              1
            );
          });
          this.$axios.delete("dci/product/extendedwarranty/attachment", {
            data: { urls: urls },
          });
        }
        this.$axios
          .request({
            url: "dci/product/extendedwarranty",
            method: "post",
            data: this.qualityItem,
          })
          .then((response) => {
            this.qualitySubmitting = false;
            this.qualityVisible = false;
            this.item.QualityStartAt = this.qualityItem.QualityStartAt;
            this.item.QualityEndAt = this.qualityItem.QualityEndAt;
            this.item.DciProductExtendWarranties.push(response.data);

            if (this.fileList.length > 0) {
              this.$refs.upload.clearFiles();
            }
            this.fileList = [];
            this.removeList = [];
            this.$message.success("更新成功");
          })
          .catch(({ response }) => {
            this.qualitySubmitting = false;
            this.$sys.alarmResponse(response);
          });
      });
    },
    changeDate(val) {
      //质保开始日期修改，质保结束日期也自动修改,默认质保开始日期开始一年
      if (val) {
        const date = this.qualityItem.QualityStartAt;
        this.qualityItem.QualityEndAt = new Date(
          date.getTime() + 3600 * 1000 * 24 * 365
        );
      } else {
        this.qualityItem.QualityEndAt = val;
      }
    },

    // param是自带参数。 this.$refs.upload.submit() 会自动调用 httpRequest方法.在里面取得file
    httpRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      formData.append("id", this.item.ID);
      this.$axios
        .post(`dci/product/extendedwarranty/attachment`, formData)
        .then((response) => {
          this.qualityItem.Attachments.push(response.data);

          this.fileList.push({
            uid: params.file.uid,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.qualitySubmitting = false;
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },

    handleRemove(file) {
      // if (file.status === "success") {
      this.removeList.push(file.uid);
      // }
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },

    onClose() {
      if (this.isEdited) {
        this.$emit("form:saved", true);
      }
      this.$emit("update:visible", false);
      this.$emit("cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.ds-detail {
  .el-tabs__header {
    z-index: 0;
  }
  .fix-width {
    width: 120px;
  }
  table th td,
  table tr td {
    padding: 2px 5px;
    height: 30px;
    line-height: 30px;
    table-layout: FIXED;
    word-break: break-all;
  }
  table th {
    text-align: center;
    // padding-left: 5px;
    color: #646566;
    background-color: #ecf5ff;
    font-size: 11px;
  }
  .border-style {
    height: 28px;
    line-height: 28px;
    border-radius: 0 15px 15px 0;
    border-left: 3px solid #409eff;
    padding-left: 5px;
    margin-bottom: 10px;
    background-color: #ecf5ff;
    color: #409eff;
    font-size: 13px;
    font-weight: bolder;
  }
}
</style>
